import axios from 'axios'
import {MessageBox, Message} from 'element-ui'
import store from '@/store'
import {getToken} from '@/utils/auth'
import defaultSetting from '@/settings'
import ErrorList from '@/ErrorList'

// create an axios instance
const service = axios.create({
    baseURL: process.env.VUE_APP_NODE_API+"/"+defaultSetting.api_version, // url = base url + request url
    withCredentials: false, // send cookies when cross-domain requests
    timeout: 10000 // request timeout
});

// request interceptor
service.interceptors.request.use(
    config => {
        if (store.getters.token) {
            config.headers['Authorization'] = store.getters.token_type+" "+getToken()
        }
        return config
    },
    error => {
        // do something with request error
        console.log(error);
        return Promise.reject(error);
    }
);

//特殊处理器
const err_process = {
    relogin(err_obj){
        MessageBox.confirm(err_obj.message,"提示",{
            confirmButtonText: '重新登录',
            cancelButtonText: '取消',
            type: err_obj.type
        }).then(() => {
            store.dispatch('user/resetToken').then(() => {
                location.reload();
            });
        });
    }
};

// response interceptor
service.interceptors.response.use(
    response => {
        const res = response.data;

        if (res.code !== 200) {
            //查找错误代码
            let err_obj = null;
            if(typeof ErrorList[res.code] !== "undefined"){
                err_obj = ErrorList[res.code];
            }else{
                err_obj = ErrorList["other"];
            }
            if(err_obj.do){
                //特殊处理
                err_process.relogin(err_obj);
            }else{
                Message({
                    message:typeof res.msg == "string" ? res.msg : err_obj.message,
                    type:err_obj.type,
                    duration:5000
                });
            }
            return Promise.reject(res);
        } else {
            return res;
        }
    },
    error => {
        //如500错误 504等...
        console.log('request error:',error);
        Message({
            message: error.message,
            type: 'error',
            duration: 5 * 1000
        });
        return Promise.reject(error)
    }
);

window.node_axios = service;

export default service
